import { render } from "./header-three.vue?vue&type=template&id=560c3831"
import script from "./header-three.vue?vue&type=script&lang=js"
export * from "./header-three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__